/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Construction type of a vehicle   * `OpenBox`     - german: offerner Kasten   * `ClosedBox`   - german: geschlossener Kasten   * `Tarpaulin`   - german: Plane/Spriegel   * `Other`       - german: sonstige
 */
export const ConstructionType = {
  OpenBox: 'OpenBox',
  ClosedBox: 'ClosedBox',
  Tarpaulin: 'Tarpaulin',
  Other: 'Other',
} as const;
export type ConstructionType = (typeof ConstructionType)[keyof typeof ConstructionType];
